import React, { useState } from "react";

import SubMenu from "./SubMenu";
import { logout } from "../../slice/authSlice";
import { useAppDispatch, useAppSelector } from "../../hook";
import { useLocation, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { logoutUser } from "../../../common/api/authApi";
import { useTranslation } from "react-i18next";
import { normalizedLocale } from "../../../common/libs/normalizedLocale";
import { deleteRoleState } from "../../slice/roleMatrix";
import { roleMatrix } from './../../slice/roleMatrix';

function SideNavbar() {
  const [open, setOpen] = useState(true);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const locale = normalizedLocale(i18n.language);
  const roleMatrix = useAppSelector(state => state.roleMatrix);
  const userData = useAppSelector(state => state.auth.userData)
  const userDataRole = userData.role[0]
  const user: any = useAppSelector((state) => state.auth.userData);
  const isSuperadmin = user && user?.isSuperadmin;
  const isAdmin = isSuperadmin || (Array.isArray(user?.roles) && user.roles.some(
    (role: any) =>
      role.nameRu?.toLowerCase().includes('админ') ||
      role.nameKk?.toLowerCase().includes('әкімш')
  ));
  console.log(userData);


  // Для суперадмина показываем только пункт "Пользователи" и "Редактор страниц"
  const Menus = isSuperadmin
    ? [
      {
        title: t("submenu.users"),
        icon: "/icons/user.svg",
        route: "/users",
        roleId: 8,
      },
      {
        title: "Редактор страниц",
        icon: "/icons/setting.svg",
        route: "/page-editor",
        roleId: 5,
      },
    ]
    : [
      {
        title: t("submenu.mainPage"),
        icon: "/icons/home.svg",
        route: "/main",
        roleId: 5,
      },
      {
        title: t("analytics.title"),
        icon: "/icons/analitik.svg",
        roleId: 3,
        SubMenuItems: [
          { title: t("analytics.income"), route: "/analytics/income", roleId: 5 },
          { title: t("analytics.cargoTurnover"), route: "/analytics/cargo-turnover", roleId: 12 },
          { title: t("analytics.cargoProcessing"), route: "/analytics/cargo-processing", roleId: 12 },
          { title: t("analytics.invoices"), route: "/analytics/invoices", roleId: 4 },
        ],
      },
      {
        title: t("submenu.voyage"),
        icon: "/icons/document.svg",
        roleId: 1,
        SubMenuItems: [
          { title: t("registryList.tabs.processed"), route: "/registry/processed", roleId: 2 },
          { title: t("registryList.tabs.planned"), route: "/registry/planned", roleId: 2 },
          { title: t("registryList.tabs.atPier"), route: "/registry/at-pier", roleId: 2 },
          { title: t("registryList.tabs.cancelled"), route: "/registry/cancelled", roleId: 2 },
          { title: "НПГРП", route: "/npgrp", roleId: 2 },
          // { title: t("submenu.inbox"), route: "/documents/inbox", roleId:5},
          // { title: t("submenu.sent"), route: "/documents/sent", roleId:6 },
          // { title: t("submenu.drafts"), route: "/documents/drafts", roleId:7 },
          // { title: t("submenu.personalization"), route: "/documents/personalization", roleId:8 },
        ],
      },
      {
        title: t("submenu.import"),
        icon: "/icons/history.svg",
        roleId: 5,
        SubMenuItems: [
          { title: "Стейтмент", route: "/imports/statement", roleId: 5 },
          { title: "Производительность", route: "/imports/performance", roleId: 5 },
          { title: "Журнал отказов", route: "/imports/incidents", roleId: 5 },
          { title: t("analytics.plans"), route: "/analytics/plans", roleId: 11 },
          { title: t("analytics.personnel"), route: "/analytics/personnel", roleId: 11 },
        ],
      },
      {
        title: "Редактор страниц",
        icon: "/icons/setting.svg",
        route: "/page-editor",
        roleId: 5,
      },
      // {
      //   title: "Тестовая страница",
      //   icon: "/icons/setting.svg",
      //   route: "/test",
      //   roleId: 5,
      // },
      // ...((isAdmin)
      // ? [
      //   {
      //     title: t("submenu.warehouse"),
      //     icon: "/icons/datamatrix.svg",
      //     roleId: 2,
      //     SubMenuItems: [
      //       { title: t("Создание склада"), route: "/warehouse", roleId: 12 },
      //       { title: t("Список складов"), route: "/warehouse-list", roleId: 4 },
      //     ],
      //   },
      // ]
      // : []),
    ];

  const Logout = { title: t("submenu.logout"), icon: "/icons/exit.svg" };

  // Функция для выхода пользователя
  const handleLogout = async () => {
    const refreshToken = Cookies.get("refresh_token");
    console.log(refreshToken);
    if (refreshToken) {
      try {
        await logoutUser(refreshToken);
        dispatch(deleteRoleState);
        dispatch(logout());
        navigate("/authorization");
      } catch (error) {
        dispatch(deleteRoleState);
        dispatch(logout());
        navigate('/authorization');
      }
    } else {
      // Если refreshToken не найден, просто диспатчим действие logout
      dispatch(deleteRoleState);
      dispatch(logout());
      navigate("/authorization");
    }
  };

  return (
    <nav
      className={` ${open ? "w-72" : "w-20 "
        } overflow-hidden bg-white  p-5  pt-[15px] relative duration-300 rounded h-full flex flex-col`}
    >
      <div
        className={`min-h-[48px] pb-3 flex items-center border-b border-solid ${
          open ? "" : "justify-center"
        }`}
      >
        {open ? (
          <>
            <div className="flex-1 min-w-0" aria-hidden />
            <div className="flex shrink-0 justify-center px-1">
              <img
                src="/icons/logo.png"
                alt="Logo"
                className="h-9 w-auto max-w-[120px] object-contain object-center"
              />
            </div>
            <div className="flex-1 flex justify-end min-w-0">
              <div
                className="cursor-pointer p-1 w-6 h-6 rounded-full flex items-center justify-center shrink-0"
                style={{ backgroundColor: "var(--main-color, #000000)" }}
                onClick={() => setOpen(!open)}
              >
                <img
                  src="/icons/double-arrow-left.svg"
                  className="w-[20px] h-[20px]"
                  alt=""
                />
              </div>
            </div>
          </>
        ) : (
          <div
            className="cursor-pointer p-1 w-6 h-6 rounded-full flex items-center justify-center"
            style={{ backgroundColor: "var(--main-color, #000000)" }}
            onClick={() => setOpen(!open)}
          >
            <img
              src="/icons/double-arrow-left.svg"
              className="w-[20px] h-[20px] rotate-180"
              alt=""
            />
          </div>
        )}
      </div>

      <ul className="pt-[18px] flex-1 m-0 flex flex-col overflow-hidden">
        <div className="flex-1 overflow-y-auto scrollbar-hide">
        {Menus.map((menu: any, index) => {
          // Для суперадмина показываем все пункты без проверки roleMatrix
          if (isSuperadmin) {
            return (
              <SubMenu
                key={`submenu-${index}-0-${menu.title}`}
                index={index}
                icon={menu.icon}
                title={menu.title}
                route={menu.route || ""}
                open={open}
                subMenuItems={menu.SubMenuItems || []}
              />
            );
          }

          // Для обычных пользователей проверяем roleMatrix
          // Редактор страниц показываем всегда (без проверки роли)
          if (menu.route === "/page-editor" || menu.title === "Редактор страниц") {
            return (
              <SubMenu
                key={`submenu-${index}-0-${menu.title}`}
                index={index}
                icon={menu.icon}
                title={menu.title}
                route={menu.route || ""}
                open={open}
                subMenuItems={menu.SubMenuItems || []}
              />
            );
          }
          
          const menuRole = roleMatrix.roleMatrix?.find(area => menu.roleId === area.id);
          // Если roleMatrix еще не загружен, показываем пункт если у него есть route
          if (!roleMatrix.isMatrix && menu.route) {
            return (
              <SubMenu
                key={`submenu-${index}-0-${menu.title}`}
                index={index}
                icon={menu.icon}
                title={menu.title}
                route={menu.route || ""}
                open={open}
                subMenuItems={menu.SubMenuItems || []}
              />
            );
          }
          
          if (menuRole && menuRole.view) {
            return (
              <SubMenu
                key={`submenu-${index}-0-${menu.title}`}
                index={index}
                icon={menu.icon}
                title={menu.title}
                route={menu.route || ""}
                open={open}
                subMenuItems={menu.SubMenuItems?.filter((subMenu: any) => {
                  const subMenuRole = roleMatrix.roleMatrix?.find(area => subMenu.roleId === area.id);
                  return subMenuRole && subMenuRole.view;
                })}
              />
            );
          }
          return null;
        })}
        </div>
        <li className="mt-4 flex-shrink-0">
          <button
            key={`meni-item-logout`}
            className={`buttonCancel w-full flex items-center gap-x-4 mt-2 ${!open && "justify-center"}`}
            onClick={handleLogout}
          >
            <img
              src={Logout.icon}
              className="block h-6 w-6 duration-200"
              style={{
                filter: 'brightness(0) saturate(100%) invert(27%) sepia(51%) saturate(2878%) hue-rotate(214deg) brightness(94%) contrast(92%)',
                minWidth: '24px',
                minHeight: '24px',
                display: 'block'
              }}
              alt="Выход"
            />
            <span className={`${!open && "hidden"} origin-left duration-200`}>
              {Logout.title}
            </span>
          </button>
        </li>
      </ul>
    </nav>
  );
}

export default SideNavbar;
